var map = {
	"./adventure.jpg": 139227,
	"./adventure_promo.jpg": 241619,
	"./adventure_wide.jpg": 342277,
	"./crocword.jpg": 66958,
	"./crocword_promo.jpg": 800742,
	"./crocword_wide.jpg": 709646,
	"./differences.jpg": 938639,
	"./differences_promo.jpg": 607303,
	"./differences_wide.jpg": 487729,
	"./fairy.jpg": 6060,
	"./fairy_promo.jpg": 64268,
	"./fairy_wide.jpg": 886216,
	"./heroes.jpg": 710939,
	"./heroes_promo.jpg": 10451,
	"./heroes_wide.jpg": 524357,
	"./hustlemerge.jpg": 550432,
	"./hustlemerge_promo.jpg": 101888,
	"./hustlemerge_wide.jpg": 726996,
	"./magicwords.jpg": 750827,
	"./magicwords_promo.jpg": 528643,
	"./magicwords_wide.jpg": 55029,
	"./mergecraft.jpg": 612525,
	"./mergecraft_promo.jpg": 449981,
	"./mergecraft_wide.jpg": 639595,
	"./olympics.jpg": 947995,
	"./olympics_promo.jpg": 355603,
	"./olympics_wide.jpg": 888901,
	"./riddles.jpg": 590770,
	"./riddles_promo.jpg": 9738,
	"./riddles_wide.jpg": 655642,
	"./runes.jpg": 408704,
	"./runes_promo.jpg": 269664,
	"./runes_wide.jpg": 233844,
	"./scramble.jpg": 699078,
	"./scramble_promo.jpg": 579198,
	"./scramble_wide.jpg": 682070,
	"./spades.jpg": 364365,
	"./spades_promo.jpg": 499357,
	"./spades_wide.jpg": 788683,
	"./tripeaks.jpg": 333614,
	"./tripeaks_promo.jpg": 132102,
	"./tripeaks_wide.jpg": 880302,
	"./wondermerge.jpg": 453968,
	"./wondermerge_promo.jpg": 232336,
	"./wondermerge_wide.jpg": 282084,
	"./woodenblock.jpg": 554710,
	"./woodenblock_promo.jpg": 956078,
	"./woodenblock_wide.jpg": 966790,
	"./wordsoup.jpg": 491702,
	"./wordsoup_promo.jpg": 379918,
	"./wordsoup_wide.jpg": 776742,
	"./zenmatch.jpg": 651221,
	"./zenmatch_promo.jpg": 195525,
	"./zenmatch_wide.jpg": 587651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486918;